import Cookies from 'js-cookie';
import { on } from '../helpers';

(function(){
    const RAKUTEN_COOKIE = 'rakuten_preference';

    const declineTracking = () => {
        Cookies.set(RAKUTEN_COOKIE, 'declined');
        window.__rmcp2 = [];
    }

    const consentTracking = () => {
        Cookies.set(RAKUTEN_COOKIE, 'consented');
        window.__rmcp2 = [1,2,3,4,5,6,7,8,9,10];
    }

    const RakutenTracking = () => {
        if (window.Shopify.customerPrivacy) {
            const userTrackingPreference = Cookies.get(RAKUTEN_COOKIE);

            /* USER ALREADY EXPRESSED PREFERENCE
             (Rakuten ask to reiterate preferences on each pageload)
            */
            if(userTrackingPreference) {
                if(window.Shopify.customerPrivacy.userCanBeTracked()) {
                    consentTracking();
                } else {
                    declineTracking();
                }
            }

            document.addEventListener('trackingConsentAccepted', consentTracking);
            on('click', '#shopify-privacy-banner-decline-button', declineTracking);
        }
    }

    // LOADING SHOPIFY CONSENT TRACKING API
    window.Shopify.loadFeatures(
        [
            {
            name: 'consent-tracking-api',
            version: '0.1',
            },
        ],
        error => {
            if (error) {
                throw error; // or no-op if you don't care about raising
            }

            RakutenTracking();
        },
    );
})();
